import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CacheService {

  private apiKey: string = environment.api_key; 

  constructor() {}

  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const value = sessionStorage.getItem(key);
    if(value == null || value == 'undefined') {
      return JSON.parse('{}');
    }
    return JSON.parse(sessionStorage.getItem(key) || '{}');
  }

  storeToken(key: string, token: string): void {
    sessionStorage.setItem(key, token);
  }

  getToken(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  clearItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  setApiKey(apiKey: string): void {
    this.apiKey = apiKey;
  }

  getApiKey(): string {
    return this.apiKey;
  }

  clearAll(): void {
    sessionStorage.clear();
  }
  
}